module.exports = __webpack_public_path__ + "static/media/profile-picture-1024w.ea095ff9.webp";